<template>
  <div class="wrap">
    <Header activeIndex="/proposition"/>
    <div class="bannerimg">
      <img src="@/assets/match/banner.png" alt="" style="width:100%;display:block;"/>
    </div>
    <div class="content">
      <div class="imgbox">
        <img src="@/assets/image/jianbian.png" alt="" width="100%" height="30px"/>
        <div class="cont">
          <div>
            由大赛办公室组织评委专家，连同命题企业的代表，开展专题赛的复评评审，评选出本专项赛的优秀作品名单，并对入围的作品给予深化设计的建议，推荐进入大赛的决赛。
          </div>
        </div>
        <div class="linebox"><div class="line"></div></div>
      </div>

      <div class="right">
        <img src="@/assets/match/photo.png" alt="" style="display:block;"/>
      </div>
    </div>
    <Footer :show="true"/>
  </div>
</template>

<script>
import Footer from "@/components/Footer/index";
import Header from "@/components/Header/Header";
export default {
  name: "proposition",
  components: { Footer,Header },
}
</script>

<style scoped lang="scss">
.wrap {
  width: 100%;

  .bannerimg {
    z-index: -2;
  }

  .content{
    width: 100%;
    margin-top: 80px;
    display: flex;
    .imgbox{
      width: 58%;
      .cont{
        width: 100%;
        height: 200px;
        background: url('../../assets/match/cont.png') no-repeat;
        background-position: center;
        margin: 80px 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        div{
          width: 50%;
          text-align: left;
          line-height: 30px;
          color: #ffffff;
          margin-right: 50px;
          font-weight: bold;
        }
      }
      .linebox{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .line{
          background-color: rgb(37, 135, 125);
          width: 45%;
          height: 10px;
          //margin-left: 80vw;
        }
      }
    }
    .right{
      width: 42%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }



}
</style>



// WEBPACK FOOTER //
// src/view/Match/proposition.vue